// extracted by mini-css-extract-plugin
module.exports = {"btn-primary":"_textinput_btn-primary__AYF6q","input":"_textinput_input__3LTgB"};